import React from "react";
import { widthPercentageToDP } from "../../Utils/ResponsiveScreen";
import CreateDynamicButton from "./CreateDynamicButton";
import DynamicButtonValidations from "./DynamicButtonValidations";
import { Button, Modal } from "react-bootstrap";

class CreateMultiDynamicButtons extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      contentNewLinkDetails: [],
      dynamicButton: false,
      buttonDiscardModal: false,
    };
    this.buttonDetailsObj = {
      category: "insideApp",
      urlType: "page",
      pageLink: "",
      appstoreLink: "",
      playstoreLink: "",
      saavnLink: "",
      gaanaLink: "",
      httpsLink: "",
      linkText: "",
      buttonPositionFromTop: "10",
      buttonPositionFromLeft: "40",
      pageList: [],
      pageInfo: {},
      selectedPageValue: null,
      peopleList: [],
      peopleInfo: {},
      selectedPeopleValue: null,
      lists: [],
      listInfo: {},
      selectedListValue: null,
      listLanguage: "Te",
      customButtonPosition: false,
    };
  }

  updateData = (input, index) => {
    let linkDetails = [];
    this.state.contentNewLinkDetails?.map((item) => {
      linkDetails.push(item);
    });
    linkDetails?.filter((item, itemIndex) => {
      if (index == itemIndex) {
        return (linkDetails[itemIndex] = input);
      }
    });

    this.setState(
      {
        contentNewLinkDetails: linkDetails,
      },
      () => {
        this.props.updatecontentNewLinkDetails(linkDetails, index);
      }
    );
  };

  changeDynamicButton = () => {
    const newLinkDetailsArr = this.state.dynamicButton
      ? []
      : [this.buttonDetailsObj];
    this.setState(
      {
        dynamicButton: !this.state.dynamicButton,
        contentNewLinkDetails: newLinkDetailsArr,
        buttonDiscardModal: false,
      },
      () => {
        this.props.updatecontentNewLinkDetails(
          this.state.contentNewLinkDetails,
          this.props.sectionIndex
        );
      }
    );
  };

  handleChangeDynamicButton = () => {
    if (this.state.dynamicButton) {
      this.setState({ buttonDiscardModal: true });
    } else {
      this.changeDynamicButton();
    }
  };

  addButton = () => {
    const linkDetailsArr = this.state.contentNewLinkDetails;
    linkDetailsArr.push(this.buttonDetailsObj);
    this.setState(
      {
        contentNewLinkDetails: linkDetailsArr,
      },
      () => {
        this.props.updatecontentNewLinkDetails(
          this.state.contentNewLinkDetails,
          this.props.sectionIndex
        );
      }
    );
  };

  removeButton = (selectedIndex) => {
    const linkDetailsArray = this.state.contentNewLinkDetails;
    let updatedLinkDetailsArray = linkDetailsArray.filter((item, index) => {
      return index != selectedIndex;
    });
    this.setState(
      {
        contentNewLinkDetails: updatedLinkDetailsArray,
      },
      () => {
        this.props.updatecontentNewLinkDetails(
          this.state.contentNewLinkDetails,
          this.props.sectionIndex
        );
      }
    );
  };

  componentDidMount() {
    if (this.props.editContent) {
      const buttonAvailable = this.props.contentNewLinkDetails?.[0]?.urlType
        ? true
        : false;
      this.setState({
        contentNewLinkDetails: this.props.contentNewLinkDetails,
        dynamicButton: buttonAvailable,
      });
    }
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.contentNewLinkDetails != this.props.contentNewLinkDetails) {
      const isButtonAvailable = this.props.contentNewLinkDetails?.[0]?.urlType
        ? true
        : false;
      this.setState({
        contentNewLinkDetails: this.props.contentNewLinkDetails,
        dynamicButton: isButtonAvailable,
      });
    }
  }

  render() {
    return (
      <div>
        <div>
          <input
            type="checkbox"
            onChange={() => this.handleChangeDynamicButton()}
            checked={this.state.dynamicButton}
          />
          <label style={{ marginLeft: widthPercentageToDP("1") }}>Button</label>
        </div>
        {this.state.dynamicButton &&
          this.state.contentNewLinkDetails?.map((item, index) => {
            const buttonValidation = DynamicButtonValidations(
              item,
              true,
              false
            );
            return (
              <div style={{ marginBottom: 12 }} key={`${index}`}>
                <details>
                  <summary>{`Button${index + 1} Details (${
                    item.urlType
                  })`}</summary>
                  <CreateDynamicButton
                    selectedContentType={this.props.selectedContentType}
                    editContent={this.props.editContent}
                    sectionIndex={this.props.index}
                    contentNewLinkDetails={item}
                    updatecontentNewLinkDetails={(input) => {
                      this.updateData(input, index);
                    }}
                    markdownLinkLables={this.props.markdownLinkLables}
                  />
                </details>
                {buttonValidation ? (
                  <div>
                    <text style={{ color: "red" }}>{`Please fill fields`}</text>
                  </div>
                ) : null}
                <div style={{ marginTop: 5 }}>
                  <button onClick={() => this.removeButton(index)}>
                    {`Remove Button${index + 1}`}
                  </button>
                </div>
              </div>
            );
          })}
        {this.state.dynamicButton ? (
          <div style={{ marginTop: 5 }}>
            <button onClick={() => this.addButton()}>Add Button</button>
          </div>
        ) : null}

        <Modal
          show={this.state.buttonDiscardModal}
          onHide={() => this.setState({ buttonDiscardModal: false })}
        >
          <Modal.Body>All Button Changes Will Be Discarded</Modal.Body>
          <Modal.Footer>
            <Button
              onClick={() => this.setState({ buttonDiscardModal: false })}
            >
              Cancel
            </Button>
            <Button onClick={() => this.changeDynamicButton()}>Ok</Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}

export default CreateMultiDynamicButtons;
